import { render, staticRenderFns } from "./BusinessPartnerSearcher.vue?vue&type=template&id=40c06996&"
import script from "./BusinessPartnerSearcher.vue?vue&type=script&lang=js&"
export * from "./BusinessPartnerSearcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports